document.addEventListener('DOMContentLoaded', function() {
  //product-form
  let productContainer = document.getElementById('product-recommended-size');
  let allSpecs = document.querySelectorAll('.product-form__option-value')
  let selectorSpecs = document.querySelectorAll('.product-form__option-selector');
  let lastSelectorSpecs = selectorSpecs[selectorSpecs.length -1];
  let blockSwatchElements = lastSelectorSpecs.querySelectorAll('.block-swatch');
  let sizeElementHeight = "";
   blockSwatchElements.forEach(function(element,index) {
      let elementInput = element.querySelector('input[type="radio"]');
      let block = element.querySelector('.product-size-content');

      sizeElementHeight = element.offsetHeight;
      let sizeDesHeight = block.offsetHeight;
      let leftWindt = (window.innerWidth - productContainer.offsetWidth) / 2;
      if(elementInput.checked && window.innerWidth < 1000){
        let option = element.querySelector(`input[name="option${selectorSpecs.length}"]`).value;
        sizeListFunc(allSpecs,option).then(res =>{
            let metaobjectText = element.querySelector('.metaobjectText')
            metaobjectText.innerHTML = res;
            block.style.display = "block" 
            let arrowImg = element.querySelector('.arrow-img');
            arrowImg.style.left = (element.offsetWidth / 2) - 5 + 'px';
            block.style.marginLeft = -(element.getBoundingClientRect().left - leftWindt) + 'px';
            block.style.width = (productContainer.offsetWidth) + 'px';
            console.log(block.offsetHeight,element.offsetHeight)
            element.style.height  = (block.offsetHeight + 49) + 'px';
        }) 
      }
      element.addEventListener('mouseenter', function() {
          if (window.innerWidth >= 1000) {
            let option = element.querySelector(`input[name="option${selectorSpecs.length}"]`).value;
            sizeListFunc(allSpecs,option).then(res =>{
              let metaobjectText = element.querySelector('.metaobjectText')
              metaobjectText.innerHTML = res;
              block.style.display = "block"
            })
          }
      });
      element.addEventListener('mouseleave', function() {
          if (window.innerWidth >= 1000) {
             block.style.display = "none"
          }
      });
      element.addEventListener('click', function() {
          if (window.innerWidth < 1000) {
             blockSwatchElements.forEach(function(item,bix) {
               let itemInput = item.querySelector('input[type="radio"]');
               let blocks = item.querySelector('.product-size-content');
               if(bix != index){
                 blocks.style.display = "none"
                 item.style.height = sizeElementHeight+ 'px';
               }
               if(bix == index && !itemInput.checked){
                  let option = element.querySelector(`input[name="option${selectorSpecs.length}"]`).value;
                  sizeListFunc(allSpecs,option).then(res =>{
                    let metaobjectText = element.querySelector('.metaobjectText')
                    metaobjectText.innerHTML = res;
                    blocks.style.display = "block"
                    let arrowImg = element.querySelector('.arrow-img');
                    arrowImg.style.left = (element.offsetWidth / 2) - 5 + 'px';
                    blocks.style.marginLeft = -(element.getBoundingClientRect().left - leftWindt) + 'px';
                    blocks.style.width = (productContainer.offsetWidth) + 'px';
                    item.style.height  = (blocks.offsetHeight + 49) + 'px';
                  }) 
               }
              })
          }else{
            block.style.display = "none"
          }
      });
  });
  if(selectorSpecs.length > 1 && window.innerWidth < 1000){
    selectorSpecs.forEach(function(element,index) {
      let allBlockSwatch = element.querySelectorAll('.block-swatch') || [];
      if(allBlockSwatch.length == 0){ allBlockSwatch = element.querySelectorAll('.variant-swatch') || []; }
      allBlockSwatch.forEach(function(item,idx) {
        let inputDome = item.querySelector('input[type="radio"]');
        inputDome.addEventListener('click', function() { 
          let inputVal = inputDome.value;
          if(inputVal && index < (allSpecs.length -1)){
            let lastOption = allSpecs[allSpecs.length -1].innerHTML;
            let list = Array.from(allSpecs).map(mx => mx.innerHTML)
            list[index] = inputVal;
            sizeListFunc(list,lastOption,2).then(res =>{
              for(let i = 0; i < blockSwatchElements.length; i++){
                let option = blockSwatchElements[i].querySelector('input[type="radio"]').value;
                if(option == lastOption){
                   let blocks =  blockSwatchElements[i].querySelector('.product-size-content');
                   if(res){
                     let metaobjectText = blockSwatchElements[i].querySelector('.metaobjectText')
                     metaobjectText.innerHTML = res;
                     blocks.style.display = 'block'
                     blockSwatchElements[i].style.height  = (blocks.offsetHeight + 49) + 'px';
                   }else{
                     blocks.style.display = 'none'
                     blockSwatchElements[i].style.height = sizeElementHeight+ 'px';
                   }
                   break;
                }
              }
            })
          }
        })
      })
    })
  }
  //product-sticky-form
  let productContainerDown = document.getElementById('product-sticky-form__form');
  let productDownList = document.querySelectorAll('.select-wrapper');
  let allSticky = document.querySelectorAll('.select__selected-value')
  let productDownListLength = productDownList[productDownList.length -1];
  let productSizeButtons = productDownListLength.querySelectorAll('.combo-box__option-item');
  productSizeButtons.forEach(function(element) {
      element.addEventListener('mouseenter', function() {
          let block = element.querySelector('.product-size-item-bottom');
          let option = element.value;
          sizeListFunc(allSticky,option).then(res =>{
            let metaobjectText = element.querySelector('.metaobjectText')
            metaobjectText.innerHTML = res;
            block.style.display = "block"
          })
      });
      element.addEventListener('mouseleave', function() {
          let block = element.querySelector('.product-size-item-bottom');
          block.style.display = "none"
      });
      element.addEventListener('click', function() {
          let block = element.querySelector('.product-size-item-bottom');
          block.style.display = "none"
      });
  });
  
  function sizeListFunc(allSticky,lastoption,type = 1){
    let metaobjectList = document.getElementById('metaobjectList');
    let sizeList = metaobjectList.querySelectorAll('.sizeList')
    return new Promise((resolve,reject) => {
      if(!sizeList.length > 0){ return false } //元对象没有时不执行下列条件
      let innerText = '';
      let specs = [];
      if(type == 1){
        allSticky.forEach((item,index) =>{ 
           let ariaLabelValue = item.querySelector('.select__color-swatch');
           if(ariaLabelValue){
              specs.push(ariaLabelValue.getAttribute('aria-label'))
            }else{
              specs.push(item.innerHTML)
            }
        }) 
      }else if(type == 2){
        specs = allSticky;
      }
      if(specs.length != 0){
        specs[specs.length - 1] = lastoption;
        let stroption = specs.join(' / ');
        for(let i = 0; i < sizeList.length; i++){
          let option = sizeList[i].getAttribute('data-option') || '';
          if(option == stroption){
            innerText = sizeList[i].innerHTML;
            resolve(sizeList[i].innerHTML)
            break;
          }
        }
        if(type == 2 && !innerText){ resolve('') } 
      }
    })
  }
}) 